<template>
  <section class="m-setting-clause m-scroll">
    <!-- 头部导航 -->
    <m-header title="条款" ></m-header>
    <div class="main">
        <p>
            隐私条款
        </p>
        <p class="line-h">
            <strong><span>Effective date: May 02, 2021</span></strong>
        </p>
        <p class="line-h">
            <span class="line-h-f">&nbsp;</span>
        </p>
        <p class="line-h">
            <span class="line-h">MC </span><span>INTERNATIONAL ENTERPRISES LTD. ("us", "we", or "our") operates the www.moobyyoho.com website (hereinafter referred to as the "Service").</span>
        </p>
        <p class="line-h">
            <span class="line-h-f">&nbsp;</span>
        </p>
        <p class="line-h">
            <span>This page informs you of our policies regarding the collection, use and disclosure of personal data when you use our Service, any other related Service,and the choices you have associated with that data.</span>
        </p>
        <p class="line-h">
            <span class="line-h-f">&nbsp;</span>
        </p>
        <p class="line-h">
            <span>We use your data to provide and improve the Service. By using the Service, you agree to the collection and use of information in accordance with this policy. Unless otherwise defined in this Privacy Policy, the terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, accessible from www.moobyyoho.com</span>
        </p>
        <p class="line-h">
            <span class="line-h-f">&nbsp;</span>
        </p>
        <p class="line-h">
            <strong><span>Definitions Service</span></strong>
        </p>
        <p class="line-h">
            <span>Service is the www.moobyyoho.com website operated by MC INTERNATIONAL ENTERPRISES LTD.</span>
        </p>
        <p class="line-h">
            <span class="line-h-f">&nbsp;</span>
        </p>
        <p class="line-h">
            <strong><span>Personal Data</span></strong>
        </p>
        <p class="line-h">
            <span>Personal Data means data about a living individual who can be identified from those data (or from those and other information either in our possession or likely to come into our possession).</span>
        </p>
        <p class="line-h">
            <span class="line-h-f">&nbsp;</span>
        </p>
        <p class="line-h">
            <strong><span>Usage Data</span></strong>
        </p>
        <p class="line-h">
            <span>Usage Data is data collected automatically either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit).</span>
        </p>
        <p class="line-h">
            <span class="line-h-f">&nbsp;</span>
        </p>
        <p class="line-h">
            <strong><span>Cookies</span></strong>
        </p>
        <p>
            <span class="h-f">cookies</span><span class="h-f">Cookies are small files stored on your device (computer or mobile device).</span>
        </p>
        <p>
            <span class="h-f">&nbsp;</span>
        </p>
        <p>
            <strong><span class="h-f">Data Controller</span></strong>
        </p>
        <p class="line-h">
            <span>Data Controller means the natural or legal person who (either alone or jointly or in common with other persons) determines the purposes for which and the manner in which any personal information are, or are to be, processed.</span>
        </p>
        <p class="line-h">
            <span>For the purpose of this Privacy Policy, we are a Data Controller of your Personal </span>
        </p>
        <p class="line-h">
            <span class="line-h-f">&nbsp;</span>
        </p>
        <p class="line-h">
            <strong><span>Data Processors (or Service Providers)</span></strong>
        </p>
        <p class="line-h">
            <span>Data Processor (or Service Provider) means any natural or legal person who processes the data on behalf of the Data Controller.</span>
        </p>
        <p>
            <span class="h-f">We may use the services of various Service Providers in order to process your data more effectively.</span>
        </p>
        <p>
            <span class="h-f">&nbsp;</span>
        </p>
        <p class="line-h">
            <strong><span>Data Subject (or User)</span></strong>
        </p>
        <p class="line-h">
            <span>Data Subject is any living individual who is using our Service and is the subject of Personal Data.</span>
        </p>
        <p class="line-h">
            <span class="line-h-f">&nbsp;</span>
        </p>
        <p class="line-h">
            <strong><span>Information Collection and Use</span></strong>
        </p>
        <p class="line-h">
            <span>We collect several different types of information for various purposes to provide and improve our Service to you.</span>
        </p>
        <p>
            <span class="h-f">Types of Data Collected</span>
        </p>
        <p>
            <span class="h-f">&nbsp;</span>
        </p>
        <p>
            <strong><span class="h-f">Personal Data</span></strong>
        </p>
        <p class="line-h">
            <span>While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you ("Personal Data"). Personally identifiable information may include, but is not limited to:</span>
        </p>
        <p>
            <span class="h-f">Email address</span>
        </p>
        <p>
            <span class="h-f">First name and last name </span>
        </p>
        <p class="line-h">
            <span>Phone number </span>
        </p>
        <p class="line-h">
            <span>Address, State, Province, ZIP/Postal code, City</span>
        </p>
        <p class="line-h">
            <span class="line-h-f">&nbsp;</span>
        </p>
        <p class="line-h">
            <strong><span>Cookie</span></strong><strong><span>Cookies and Usage Data  </span></strong>
        </p>
        <p class="line-h">
            <span>We may use your Personal Data to contact you with newsletters, marketing or promotional materials and other information that may be of interest to you. You may opt out of receiving any, or all, of these communications from us by contacting us.</span>
        </p>
        <p class="line-h">
            <span class="line-h-f">&nbsp;</span>
        </p>
        <p>
            <strong><span class="h-f">Usage Data</span></strong>
        </p>
        <p class="line-h">
            <span>We may also collect information on how the Service is accessed and used ("Usage Data"). This Usage Data may include information such as your computer's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers and other diagnostic data.</span>
        </p>
        <p class="line-h">
            <span class="line-h-f">&nbsp;</span>
        </p>
        <p>
            <strong><span class="h-f">Location Data</span></strong>
        </p>
        <p class="line-h">
            <span>We may use and store information about your location if you give us permission to do so ("Location Data"). We use this data to provide features of our Service, to improve and customize our Service.</span>
        </p>
        <p class="line-h">
            <span>You can enable or disable location services when you use our Service at any time by way of your device settings.</span>
        </p>
        <p class="line-h">
            <span class="line-h-f">&nbsp;</span>
        </p>
        <p class="line-h">
            <strong><span>Tracking & Cookies Data</span></strong>
        </p>
        <p class="line-h">
            <span>We use cookies and similar tracking technologies to track the activity on our Service and we hold certain information.</span>
        </p>
        <p class="line-h">
            <span class="line-h-f">cookies</span><span class="line-h-f">Cookies are files with a small amount of data which may include an anonymous unique identifier. Cookies are sent to your browser from a website and stored on your device. Other tracking technologies are also used such as beacons, tags and scripts to collect and track information and to improve and analyse our Service.</span>
        </p>
        <p>
            <span class="h-f">You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Service.</span>
        </p>
        <p class="line-h">
            <span>Examples of Cookies we use:</span>
        </p>
        <p class="line-h">
            <span class="line-h-f">Session Cookies</span><span>We use Session Cookies to operate our Service.</span>
        </p>
        <p class="line-h">
            <span class="line-h-f">Preference Cookies</span><span>We use Preference Cookies to remember your preferences and various settings.</span>
        </p>
        <p class="line-h">
            <span class="line-h-f">Security Cookies</span><span>We use Security Cookies for security purposes.</span>
        </p>
        <p class="line-h">
            <span class="line-h-f">Advertising Cookies.</span><span class="line-h-f">Advertising Cookies are used to serve you with advertisements that may be relevant to you and your interests.</span>
        </p>
        <p class="line-h">
            <span class="line-h-f">&nbsp;</span>
        </p>
        <p class="line-h">
            <strong><span>Use of Data</span></strong>
        </p>
        <p class="line-h">
            <span class="line-h">MC </span><span>INTERNATIONAL ENTERPRISES LTD. uses the collected data for various purposes:</span>
        </p>
        <p class="line-h">
            <span>To provide and maintain our Service</span>
        </p>
        <p class="line-h">
            <span>To notify you about changes to our Service</span>
        </p>
        <p class="line-h">
            <span>To allow you to participate in interactive features of our Service when you choose to do so</span>
        </p>
        <p class="line-h">
            <span class="line-h-f">&nbsp;</span>
        </p>
        <p class="line-h">
            <strong><span>To provide customer support</span></strong>
        </p>
        <p class="line-h">
            <span>To gather analysis or valuable information so that we can improve our Service</span>
        </p>
        <p class="line-h">
            <span>To monitor the usage of our Service</span>
        </p>
        <p class="line-h">
            <span>To detect, prevent and address technical issues</span>
        </p>
        <p class="line-h">
            <span>To provide you with news, special offers and general information about other goods, services and events which we offer that are similar to those that you have already purchased , enquired or participated about unless you have opted not to receive such information</span>
        </p>
        <!-- <p class="line-h">
            <span>您可以选择不接受这样的信息。</span>
        </p> -->
        <p class="line-h">
            <span>Legal Basis for Processing Personal Data under the General Data Protection Regulation (GDPR)</span>
        </p>
        <p  class="line-h">
            <span>MC </span><span>INTERNATIONAL ENTERPRISES LTD. may process your Personal Data because:</span>
        </p>
        <p class="line-h">
            <span>We need to perform a contract with you</span>
        </p>
        <p class="line-h">
            <span>You have given us permission to do so</span>
        </p>
        <p class="line-h">
            <span>The processing is in our legitimate interests and it is not overridden by your rights</span>
        </p>
        <p class="line-h">
            <span class="line-h-f">&nbsp;</span>
        </p>
        <p class="line-h">
            <strong><span>For payment processing purposes</span></strong>
        </p>
        <p class="line-h">
            <strong><span>To comply with the law</span></strong>
        </p>
        <p>
            <strong><span class="h-f">Retention of Data</span></strong>
        </p>
        <p class="line-h">
            <span>MC INTERNATIONAL ENTERPRISES LTD. will retain your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes and enforce our legal agreements and policies.</span>
        </p>
        <p class="line-h">
            <span class="line-h">MC </span><span class="line-h">INTERNATIONAL ENTERPRISES LTD. will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period of time, except when this data is used to strengthen the security or to improve the functionality of our Service, or we are legally obligated to retain this data for longer periods.</span>
        </p>
        <p class="line-h">
            <span class="line-h-f">&nbsp;</span>
        </p>
        <p class="line-h">
            <strong><span>Transfer of Data</span></strong>
        </p>
        <p class="line-h">
            <span>Your information, including Personal Data, may be transferred to — and maintained on — computers located outside of your state, province, country or other governmental jurisdiction where the data protection laws may differ from those of your jurisdiction.</span>
        </p>
        <p class="line-h">
            <span>If you are located outside Canada and choose to provide information to us, please note that we transfer the data, including Personal Data, to Canada and process it there.</span>
        </p>
        <p class="line-h">
            <span>Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer.</span>
        </p>
        <p class="line-h">
            <span>MC INTERNATIONAL ENTERPRISES LTD. will take all the steps reasonably necessary to ensure that your data is treated securely and in accordance with this Privacy Policy and no transfer of your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of your data and other personal information.</span>
        </p>
        <p class="line-h">
            <span class="line-h-f">&nbsp;</span>
        </p>
        <p class="line-h">
            <strong><span>Disclosure of Data</span></strong>
        </p>
        <p class="line-h">
            <strong><span>Business Transaction</span></strong>
        </p>
        <p class="line-h">
            <span>If MC INTERNATIONAL ENTERPRISES LTD. is involved in a merger, acquisition or asset sale, your Personal Data may be transferred. We will provide notice before your Personal Data is transferred and becomes subject to a different Privacy Policy.</span>
        </p>
        <p class="line-h">
            <span class="line-h-f">&nbsp;</span>
        </p>
        <p>
            <strong><span class="h-f">Disclosure for Law Enforcement</span></strong>
        </p>
        <p class="line-h">
            <span>Under certain circumstances, MC INTERNATIONAL ENTERPRISES LTD. may be required to disclose your Personal Data if required to do so by law or in response to valid requests by public authorities (e.g. a court or a government agency).</span>
        </p>
        <p class="line-h">
            <span class="line-h-f">&nbsp;</span>
        </p>
        <p class="line-h">
            <strong><span>Legal Requirements</span></strong>
        </p>
        <p class="line-h">
            <span>MC </span><span>INTERNATIONAL ENTERPRISES LTD. may disclose your Personal Data in the good faith belief that such action is necessary to:</span>
        </p>
        <p class="line-h">
            <strong><span>To comply with a legal obligation</span></strong>
        </p>
        <p class="line-h">
            <span>To protect and defend the rights or property of MC INTERNATIONAL ENTERPRISES LTD.</span>
        </p>
        <p class="line-h">
            <span>To prevent or investigate possible wrongdoing in connection with the Service</span>
        </p>
        <p class="line-h">
            <span>To prevent or investigate possible wrongdoing in connection with the Service</span>
        </p>
        <p class="line-h">
            <span>To protect against legal liability</span>
        </p>
        <p class="line-h">
            <strong><span>Security of Data </span></strong>
        </p>
        <p class="line-h">
            <span>The security of your data is important to us but remember that no method of transmission over the Internet or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.</span>
        </p>
        <p class="line-h">
            <span>You can enable or disable Do Not Track by visiting the Preferences or Settings page of your web browser.</span>
        </p>
        <p class="line-h">
            <span>If you wish to be informed about what Personal Data we hold about you and if you want it to be removed from our systems, please contact us.</span>
        </p>
        <p class="line-h">
            <span>In certain circumstances, you have the following data protection rights:</span>
        </p>
        <p class="line-h">
            <span>The right to access, update or delete the information we have on you. Whenever made possible, you can access, update or request deletion of your Personal Data directly within your account settings section. If you are unable to perform these actions yourself, please contact us to assist you.</span>
        </p>
        <p class="line-h">
            <span>The right of rectification. You have the right to have your information rectified if that information is inaccurate or incomplete.</span>
        </p>
        <p class="line-h">
            <span>The right to object. You have the right to object to our processing of your Personal Data.</span>
        </p>
        <p class="line-h">
            <span>The right of restriction. You have the right to request that we restrict the processing of your personal information.</span>
        </p>
        <p class="line-h">
            <span>The right to data portability. You have the right to be provided with a copy of the information we have on you in a structured, machine-readable and commonly used format.</span>
        </p>
        <p class="line-h">
            <span>The right to withdraw consent. You also have the right to withdraw your consent at any time where MC INTERNATIONAL ENTERPRISES LTD. relied on your consent to process your personal information.</span>
        </p>
        <p class="line-h">
            <span>Please note that we may ask you to verify your identity before responding to such requests.</span>
        </p>
        <p class="line-h">
            <span class="line-h-f">&nbsp;</span>
        </p>
        <p class="line-h">
            <strong><span>Service Providers</span></strong>
        </p>
        <p class="line-h">
            <span>We may employ or collaborate with third party companies and individuals to facilitate our Service ("Service Providers"), provide the Service on our behalf, perform Service-related services or assist us in analyzing how our Service is used.</span>
        </p>
        <p class="line-h">
            <span>These third parties have access to your Personal Data only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose.</span>
        </p>
        <p class="line-h">
            <span class="line-h-f">&nbsp;</span>
        </p>
        <p>
            <strong><span class="h-f">Advertising</span></strong>
        </p>
        <p>
            <span class="h-f">We may use third-party Service Providers to show advertisements to you to help support and maintain our Service.</span>
        </p>
        <p class="line-h">
            <span>Google AdSense & DoubleClick Cookie</span>
        </p>
        <p class="line-h">
            <span>Google, as a third party vendor, uses cookies to serve ads on our Service. Google's use of the DoubleClick cookie enables it and its partners to serve ads to our users based on their visit to our Service or other websites on the Internet.</span>
        </p>
        <p class="line-h">
            <span>You may opt out of the use of the DoubleClick Cookie for interest-based advertising by visiting the Google Ads Settings web page: http://www.google.com/ads/preferences/</span>
        </p>
        <p class="line-h">
            <span class="line-h-f">Behavioral Remarketing</span><span class="line-h-f"></span>
        </p>
        <p class="line-h">
            <span class="line-h">MC </span><span>INTERNATIONAL ENTERPRISES LTD. uses remarketing services to advertise on third party websites to you after you visited our Service. We and our third-party vendors use cookies to inform, optimise and serve ads based on your past visits to our Service.</span>
        </p>
        <p class="line-h">
            <span class="line-h-f">&nbsp;</span>
        </p>
        <p>
            <strong><span class="h-f">Google Ads (AdWords)</span></strong>
        </p>
        <p class="line-h">
            <span>Google Ads (AdWords) remarketing service is provided by Google Inc.</span>
        </p>
        <p class="line-h">
            <span>You can opt-out of Google Analytics for Display Advertising and customise the Google Display Network ads by visiting the Google Ads Settings page: http://www.google.com/settings/ads</span>
        </p>
        <p class="line-h">
            <span>Google also recommends installing the Google Analytics Opt-out Browser Add-on - https://tools.google.com/dlpage/gaoptout - for your web browser. Google Analytics Opt-out Browser Add-on provides visitors with the ability to prevent their data from being collected and used by Google Analytics.</span>
        </p>
        <p class="line-h">
            <span>For more information on the privacy practices of Google, please visit the Google Privacy & Terms web page: https://policies.google.com/privacy?hl=en</span>
        </p>
        <p class="line-h">
            <span class="line-h-f">&nbsp;</span>
        </p>
        <p class="line-h">
            <strong><span>Twitter</span></strong>
        </p>
        <p class="line-h">
            <span class="line-h-f">Twitter</span><span class="line-h-f">remarketing service is provided by Twitter Inc.</span>
        </p>
        <p class="line-h">
            <span>You can opt-out from Twitter's interest-based ads by following their instructions: https://support.twitter.com/articles/20170405</span>
        </p>
        <p class="line-h">
            <span>You can learn more about the privacy practices and policies of Twitter by visiting their Privacy Policy page: https://twitter.com/privacy</span>
        </p>
        <p class="line-h">
            <span class="line-h-f">&nbsp;</span>
        </p>
        <p class="line-h">
            <strong><span>Facebook</span></strong>
        </p>
        <p class="line-h">
            <span class="line-h-f">Facebook</span><span class="line-h-f">remarketing service is provided by Facebook Inc.</span>
        </p>
        <p class="line-h">
            <span>To opt-out from Facebook's interest-based ads, follow these instructions from Facebook: https://www.facebook.com/help/568137493302217</span>
        </p>
        <p class="t-a-l">
            <span>Facebook adheres to the Self-Regulatory Principles for Online Behavioural </span>
        </p>
        <p class="t-a-l">
            <span>Advertising established by the Digital Advertising Alliance. You can also opt-out from Facebook and other participating companies through the Digital Advertising Alliance in the USA http://www.aboutads.info/choices/, the Digital Advertising Alliance of Canada in Canada http://youradchoices.ca/ or the European Interactive Digital Advertising Alliance in Europe http://www.youronlinechoices.eu/, or opt-out using your mobile device settings.</span>
        </p>
        <p class="line-h">
            <span>For more information on the privacy practices of Facebook, please visit Facebook's Data Policy: https://www.facebook.com/privacy/explanation</span>
        </p>
        <p class="line-h">
            <span class="line-h-f">&nbsp;</span>
        </p>
        <p class="line-h">
            <strong><span>Pinterest</span></strong>
        </p>
        <p class="line-h">
            <span class="line-h-f">Pinterest</span><span>remarketing service is provided by Pinterest Inc.</span>
        </p>
        <p class="t-a-l">
            <span>You can opt-out from Pinterest's interest-based ads by enabling the "Do Not Track" functionality of your web browser or by following Pinterest instructions: http://help.pinterest.com/en/articles/personalization-and-data</span>
        </p>
        <p class="t-a-l">
            <span>You can learn more about the privacy practices and policies of Pinterest by visiting their Privacy Policy page: https://about.pinterest.com/en/privacy-policy</span>
        </p>
        <p class="line-h">
            <span class="line-h-f">&nbsp;</span>
        </p>
        <p class="line-h">
            <strong><span>Payments</span></strong>
        </p>
        <p class="line-h">
            <span>We may provide paid products and/or services within the Service. In that case, we use third-party services for payment processing (e.g. payment processors).</span>
        </p>
        <p class="line-h">
            <span>We will not store or collect your payment card details. That information is provided directly to our third-party payment processors whose use of your personal information is governed by their Privacy Policy. These payment processors adhere to the standards set by PCI-DSS as managed by the PCI Security Standards Council, which is a joint effort of brands like Visa, MasterCard, American Express and Discover. PCI-DSS requirements help ensure the secure handling of payment information.</span>
        </p>
        <p class="line-h">
            <span>The payment processors we work with are:</span>
        </p>
        <p class="line-h">
            <span class="line-h-f">&nbsp;</span>
        </p>
        <p class="line-h">
            <strong><span>PayPal/ Bambora </span></strong>
        </p>
        <p class="t-a-l">
            <span>Their Privacy Policy can be viewed at https://www.paypal.com/webapps/mpp/ua/privacy-full</span>
        </p>
        <p class="line-h">
            <span class="line-h-f">Bambora</span>
        </p>
        <p class="line-h">
            <span>Their Privacy Policy can be viewed at https://www.bambora.com/en/ca/privacy-policy/</span>
        </p>
        <p class="line-h">
            <span class="line-h-f">&nbsp;</span>
        </p>
        <p class="line-h">
            <strong><span>WeChat</span></strong><strong><span></span></strong>
        </p>
        <p class="line-h">
            <span>Their Privacy Policy can be viewed at https://www.wechat.com/en/privacy_policy.html</span>
        </p>
        <p class="line-h">
            <span class="line-h-f">&nbsp;</span>
        </p>
        <p class="line-h">
            <strong><span>Alipay</span></strong><strong><span></span></strong>
        </p>
        <p class="t-a-l">
            <span>Their Privacy Policy can be viewed at https://render.alipay.com/p/f/agreementpages/alipayglobalprivacypolicy.html</span>
        </p>
        <p class="t-a-l">
            <span>&nbsp;</span>
        </p>
        <p class="line-h">
            <strong><span>Links to Other Sites </span></strong>
        </p>
        <p class="line-h">
            <span>Our Service may contain links to other sites that are not operated by us. If you click a third party link, you will be directed to that third party's site. We strongly advise you to review the Privacy Policy of every site you visit.</span>
        </p>
        <p class="line-h">
            <span>We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.</span>
        </p>
        <p class="line-h">
            <span class="line-h-f">&nbsp;</span>
        </p>
        <p class="line-h">
            <strong><span>Children's Privacy </span></strong>
        </p>
        <p class="line-h">
            <span>We do not knowingly collect personally identifiable information from anyone under the age of 18. If you are a parent or guardian and you are aware that your Child has provided us with Personal Data, please contact us. If we become aware that we have collected Personal Data from children without verification of parental consent, we take steps to remove that information from our servers.</span>
        </p>
        <p class="line-h">
            <span>Changes to This Privacy Policy</span>
        </p>
        <p class="line-h">
            <span>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.</span> <span> We will let you know via email and/or a prominent notice on our Service, prior to the change becoming effective and update the "effective date" at the top of this Privacy Policy.</span>
        </p>
        <p class="line-h">
            <span class="line-h-f">&nbsp;</span>
        </p>
        <p class="line-h">
            <strong><span>Contact Us</span></strong>
        </p>
        <p class="line-h">
            <span>If you have any questions about this Privacy Policy, please contact us:</span>
        </p>
        <p class="line-h">
            <span>By email: customerservice@moobyyoho.com</span>
        </p>
        <p class="line-h">
            <span class="line-h-f">&nbsp;</span>
        </p>
    </div>
  </section>
</template>

<script>
import MHeader  from '@/components/zh/m-header.vue'

export default {
  name:'Clause',
  components:{ MHeader },
  data(){
    return {
      
    }
  }
}
</script>

<style lang="less" scoped>
.m-setting-clause {
  width: 100%;
  height: 100%;
  background-color: #F5F9FF;
  padding-top:44px;
  overflow-y: auto;
  .main {
    margin-top: 12px;
    width: 100%;
    padding: 0 16px;
    font-size: 16px;
    >p:first-child {
        font-size:19px;text-align: center;font-size: 30px;margin-bottom:50px;font-weight: 600;
    }
    .line-h {
        line-height: 150%;
    }
    .line-h-f {
        line-height: 150%;
        font-size: 14px;
    }
    .h-f {
        font-size: 14px;
    }
    .t-a-l {
        text-align: center;
        line-height: 150%;
    }
  }
}
</style>